<template>
    <div ref="pageBox">
        <LabelContent :title="$t('base.baseinfo')" ref="LabelContent">
            <div slot="btns">
            </div>
        </LabelContent>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" :rules="searchData" ref="searchData" :model="searchParams"
                     label-width="110px"
                     class="unitWidth" size="small">
                <el-form-item :label="$t('Account.spareCode')" prop="spCode">
                    <el-input v-model.trim="searchParams.spCode" :placeholder="$t('User.input')"></el-input>
                              <!--:disabled="ifAdd ? false : true"></el-input>-->
                </el-form-item>
                <el-form-item :label="$t('Account.spareName')" prop="spName">
                    <el-input v-model.trim="searchParams.spName" :placeholder="$t('User.input')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.sort')">
                    <el-select v-model="searchParams.spLevel" clearable :placeholder="$t('base.PleaseSelect')">
                        <el-option label="A" value="A"></el-option>
                        <el-option label="B" value="B"></el-option>
                        <el-option label="C" value="C"></el-option>
                        <el-option label="D" value="D"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.spareBrand')">
                    <el-input v-model.trim="searchParams.spBrand" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareModel')">
                    <el-input v-model.trim="searchParams.spModel" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.unit')">
                    <el-select v-model="searchParams.unit" :placeholder="$t('base.PleaseSelect')" clearable filterable>
                        <el-option
                            v-for="unit in unitList"
                            :key="unit.unitId"
                            :label="unit.unitDesc"
                            :value="unit.unitDesc">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Shift.factory')" prop="fcCode">
                    <el-select v-model="searchParams.fcCode" :placeholder="$t('User.select')" :disabled="codeShow" :clearable="isclear"
                               @change="fcChange">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.factoryId"
                            :label="factory.fcName"
                            :value="factory.fcCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.spareSort')" prop="spcId">
                    <el-select v-model="searchParams.spcId" :placeholder="$t('User.select')" clearable filterable
                               @change="selectChange">
                        <el-option
                            v-for="classify in classifyList"
                            :key="classify.spcId"
                            :label="classify.spcName"
                            :value="classify.spcId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="当前库存">
                    <el-input-number v-model.trim="searchParams.spSurplusStock" :min="0" placeholder="请输入当前库存(必填)">
                    </el-input-number>
                </el-form-item>-->
                <el-form-item :label="$t('Account.safetyStock')">
                    <el-input-number v-model.trim="searchParams.spSafeStock" :min="0" :placeholder="$t('base.PleaseEnter')">
                    </el-input-number>
                </el-form-item>
                <el-form-item :label="$t('Account.stockCeil')">
                    <el-input-number v-model.trim="searchParams.spMaxStock" :min="0" :placeholder="$t('base.PleaseEnter')">
                    </el-input-number>
                </el-form-item>
                <el-form-item :label="$t('Account.price')">
                    <el-input-number v-model="searchParams.spPrice" :precision="2" :step="0.1"
                                     :min="0"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('Account.supplierCode')">
                    <el-input v-model.trim="searchParams.supplierCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.supplierName')">
                    <el-input v-model.trim="searchParams.supplierName" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.CostCenter')">
                    <el-input v-model.trim="searchParams.costCenter" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.remark')">
                    <el-input v-model.trim="searchParams.remark" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="updatePartInfo('searchData')">{{$t('base.confirm')}}</el-button>
                </el-form-item>
            </el-form>
            <el-form slot="form" :inline="true" label-width="110px" class="unitWidth" size="small">
                <el-form-item :label="$t('Account.annex')">
                    <el-upload
                        :headers="{'X-Auth-Token': token}"
                        :action="URL"
                        :on-success="handleSuccess"
                        :on-remove="delImg"
                        :file-list="fileList"
                        :before-upload="beforeAvatarUpload"
                        :limit="1">
                        <el-button size="small" type="primary">{{$t('msg.Upload')}}</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('Account.spareRecord')" ref="LabelContent" v-if="ifAdd ? false : true">
        </LabelContent>
        <div class="tableBox" v-if="ifAdd ? false : true">
            <el-table stripe ref="multipleTable" :data="sparePartInfoLogList" class="center" border>
                <el-table-column prop="operationModel.desc" sortable :label="$t('Account.operationLog')" width="125"/>
                <el-table-column prop="userName" sortable :label="$t('Account.operator')" width="110"/>
                <el-table-column prop="createTime" sortable :label="$t('Account.operationTime')" width="150"/>
                <el-table-column prop="operationType.desc" sortable :label="$t('Account.operationType')" width="130"/>
                <el-table-column prop="operationDesc" sortable :label="$t('Account.operationDesc')"/>
            </el-table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import { getSparePartInfoSpCode } from '../../../libs/api'

    export default {
        name: 'addSparePartInfo',
        data() {
            return {
                searchParams: {
                    spName: '',
                    spLevel: '',
                    spCode: '',
                    spBrand: '',
                    spModel: '',
                    remark: '',
                    unit: '',
                    spcId: '',
                    fcCode: '',
                    spSurplusStock: '',
                    spSafeStock: '',
                    spMaxStock: '',
                    spPrice: '',
                    supplierCode: '',
                    supplierName: '',
                    costCenter: '',
                    fileUrl: ''
                },
                searchData: {
                    spCode: [
                        {
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    spName: [
                        {
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    spcId: [
                        {
                            required: true,
                            message: this.$t('base.PleaseSelect'),
                            trigger: 'blur'
                        }
                    ],
                    fcCode: [
                        {
                            required: true,
                            message: this.$t('base.PleaseSelect'),
                            trigger: 'blur'
                        }
                    ]
                },
                classifyList: [],
                factoryList: [],
                unitList: [],
                ifAddText: '',
                ifAdd: false,
                codeShow: false,
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                sparePartInfoLogList: [],
                URL: '',
                token: '',
                fileList: []
            }
        },
        created() {
            this.URL = 'https://tpm.joysonsafety.com.cn/api/upload/files'
            this.token = sessionStorage.getItem('authToken')
            this.init()
        },
        methods: {
            init() {
                this.ifAddText = this.$route.params.spareIfAddText
                if (this.ifAddText == undefined || this.ifAddText == '') {
                    this.ifAddText = JSON.parse(sessionStorage.getItem('spareIfAddText'))
                }
                if (this.ifAddText == '0') {
                    this.searchParams = {}
                    this.ifAdd = true
                    this.codeShow = false
                    sessionStorage.setItem('spareIfAddText', JSON.stringify(this.ifAddText))
                } else {
                    this.ifAdd = false
                    this.codeShow = true
                    sessionStorage.setItem('spareIfAddText', JSON.stringify(this.ifAddText))
                    if (this.$route.params.spareLingInfo != undefined && this.$route.params.spareLingInfo != '') {
                        this.searchParams = this.$route.params.spareLingInfo
                        sessionStorage.setItem('spareLingInfo', JSON.stringify(this.searchParams))
                    } else {
                        this.searchParams = JSON.parse(sessionStorage.getItem('spareLingInfo'))
                    }
                }
                if (this.ifAdd) {
                    var arr = Math.round(Math.random() * 100)
                    var dateArr = moment(new Date()).format('YYYYMMDDHHmmss')
                    // this.searchParams.spCode = 'SPAREPART' + dateArr + arr
                }
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                        this.codeShow = true
                    }
                }
                this.getAllFactory()
                this.getUnitList()
                this.getSparePartInfoLogList()
            },
            handleSuccess(res, file) {
                this.fileList.push({ name: file.response.data, url: file.response.data })
                for (let i = 0; i < this.fileList.length; i++) {
                    if (this.searchParams.fileUrl) {
                        this.searchParams.fileUrl += this.fileList[i].url + ','
                    } else {
                        this.searchParams.fileUrl = this.fileList[i].url + ','
                    }
                }
                this.searchParams.fileUrl = this.searchParams.fileUrl.substring(0, this.searchParams.fileUrl.length -1)
            },
            delImg(file, fileList) {
                let str = ''
                this.fileList = fileList
                if (fileList && fileList.length > 0) {
                    for (let i = 0; i < fileList.length; i++) {
                        if (str) {
                            str += fileList[i].response.data + ','
                        } else {
                            str = fileList[i].response.data + ','
                        }
                    }
                }
                str = str.substring(0, str.length - 1)
                this.searchParams.fileUrl = str
            },
            beforeAvatarUpload(file) {
                const isLtXM = file.size / 1024 / 1024 < 5
                if (!isLtXM) {
                    this.$message.warning(this.$t('msg.max'))
                }
                return isLtXM
            },
            getSparePartInfoSpCode() {
                let params = {
                    spCode: this.searchParams.spCode,
                    fcCode: this.searchParams.fcCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.getSparePartInfoSpCode,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            this.searchParams = JSON.parse(JSON.stringify(response.data))
                            if (this.searchParams.fileUrl) {
                                let list = this.searchParams.fileUrl.split(",")
                                for (let i = 0; i < list.length; i++) {
                                    this.fileList.push({ name: list[i], url: list[i] })
                                }
                            }
                        }
                    }
                })
            },
            fcChange() {
                this.searchParams.spcId = ''
                this.getPartClassifyList()
            },
            selectChange() {
                this.$forceUpdate()
            },
            updatePartInfo(searchData) {
                this.$refs[searchData].validate((valid) => {
                    if (valid) {
                        //ifAdd true新增、false编辑
                        var url = ''
                        this.ifAdd ? url = this.$api.addSparePartInfo : url = this.$api.editSparePartInfo
                        this.addLingInfo(url)
                    } else {
                        return false
                    }
                })
            },
            addLingInfo(url) {
                if (this.searchParams.spCode == undefined || this.searchParams.spCode == '') {
                    this.$message.info(this.$t('base.PleaseEnter'))
                    return
                }
                if (this.searchParams.spName == undefined || this.searchParams.spName == '') {
                    this.$message.info(this.$t('base.PleaseEnter'))
                    return
                }
                /*if (this.searchParams.spLevel == undefined || this.searchParams.spLevel == '') {
                    this.$message.info('请选择分类！')
                    return
                }
                if (this.searchParams.spBrand == undefined || this.searchParams.spBrand == '') {
                    this.$message.info('请输入备件品牌！')
                    return
                }
                if (this.searchParams.spModel == undefined || this.searchParams.spModel == '') {
                    this.$message.info('请输入备件型号！')
                    return
                }
                if (this.searchParams.unit == undefined || this.searchParams.unit == '') {
                    this.$message.info('请选择单位！')
                    return
                }*/
                if (this.searchParams.spcId == undefined || this.searchParams.spcId == '') {
                    this.$message.info(this.$t('base.PleaseSelect'))
                    return
                }
                if (this.searchParams.fcCode == undefined || this.searchParams.fcCode == '') {
                    this.$message.info(this.$t('base.PleaseSelect'))
                    return
                }
                /*if(this.searchParams.spSurplusStock == undefined || this.searchParams.spSurplusStock == ''){
                    this.$message.info('请输入当前库存！')
                    return;
                }*/
                if (this.searchParams.spSafeStock === undefined || this.searchParams.spSafeStock === '') {
                    this.$message.info(this.$t('base.PleaseEnter')+' '+this.$t('Account.safetyStock'))
                    return
                }
                if (this.searchParams.spMaxStock == undefined || this.searchParams.spMaxStock == '') {
                    this.$message.info(this.$t('base.PleaseEnter')+' '+this.$t('Account.stockCeil'))
                    return
                }
                if (this.searchParams.spSafeStock != undefined && this.searchParams.spSafeStock != '') {
                    if (this.searchParams.spMaxStock == undefined || this.searchParams.spMaxStock == '') {
                        this.$message.info(this.$t('base.PleaseEnter')+' '+this.$t('Account.stockCeil'))
                        return
                    }
                    /*if (this.searchParams.spSafeStock >= this.searchParams.spMaxStock) {
                        this.$message.error('库存上限必须大于安全库存！')
                        return
                    }*/
                }
                /*if (this.searchParams.spPrice == undefined || this.searchParams.spPrice == '') {
                    this.$message.info('请输入价格！')
                    return
                }
                if (this.searchParams.supplierCode == undefined || this.searchParams.supplierCode == '') {
                    this.$message.info('请输入供应商编码！')
                    return
                }
                if (this.searchParams.supplierName == undefined || this.searchParams.supplierName == '') {
                    this.$message.info('请输入供应商名称！')
                    return
                }
                if (this.searchParams.remark == undefined || this.searchParams.remark == '') {
                    this.$message.info('请输入备注！')
                    return
                }*/
                let options = {
                    method: 'POST',
                    url: url,
                    data: this.searchParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.$message.success(this.ifAdd == true ? this.$t('base.SuccessfullyAdded') : this.$t('base.SuccessfullyUpdated'))
                        this.$router.push({
                            name: 'sparePartInfo'
                        })
                    } else {
                        this.$message.error(response.message)
                    }
                })
            },
            getPartClassifyList() {
                let params = {}
                this.classifyList = []
                if (this.searchParams.fcCode != undefined && this.searchParams.fcCode != '') {
                    params['fcCode'] = this.searchParams.fcCode
                } else {
                    return
                }
                let options = {
                    method: 'get',
                    url: this.$api.partClassifyList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.classifyList = response.data
                    }
                })
            },
            getAllFactory() {
                let options = {
                    method: 'get',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryList = []
                        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                        var aa = response.data
                        if (this.ischeck) {
                            for (var i = 0; i < aa.length; i++) {
                                for (let j = 0; j < userInfo.roles.length; j++) {
                                    if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                    }
                                }
                            }
                        } else {
                            this.factoryList = response.data
                        }
                        if (this.ifAdd && this.ischeck) {
                            this.searchParams.fcCode = this.userInfo.fcCode
                        }
                    }
                    this.getPartClassifyList()
                    if (!this.ifAdd) {
                        this.getSparePartInfoSpCode()
                    }
                })
            },
            getUnitList() {
                let options = {
                    method: 'get',
                    url: this.$api.unitList
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.unitList = response.data
                    }
                })
            },
            getSparePartInfoLogList(){
                this.sparePartInfoLogList = []
                let params = {
                    fcCode: this.searchParams.fcCode,
                    spCode: this.searchParams.spCode
                }
                let options = {
                    method: 'get',
                    url: this.$api.sparePartInfoLogList,
                    params: params
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        if(response.data != undefined && response.data != ''){
                            this.sparePartInfoLogList = response.data
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
